import OfferActiveStateGuard from '@components/display/OfferActiveStateGuard'
import Layout from '@components/layout/Main'
import TwoColumns from '@components/layout/TwoColumns'
import DisplaySection from '@components/display/DisplaySection'
import Breadcrumbs from '@components/breadcrumbs/Breadcrumbs'
import TitlePrice from '@components/display/TitlePrice'
import ActivePhotoContext from '@context/ActivePhotoContext'
import Triptic from '@components/display/Triptic'
import Photo from '@components/display/photos/MainPhoto'
import Thumbnails from '@components/display/photos/Thumbnails'
import UserDetails from '@components/display/user/Details'
import UserLocation from '@components/display/user/Location'
import Flag from '@components/display/flag/DynamicFlag'
import Seo from 'src/seo/components/Seo'
import JsonLdDisplay from 'src/seo/jsonld/JsonLdDisplay'

import { HEAVY_LINK_BASE } from '@constants/searchFormLinks'
import ShortSpecifications from '@components/display/offer/ShortSpecificationsAlt'
import Specifications from '@components/display/offer/Specifications'
import Equipment from '@components/display/offer/Equipment'

import Description from '@components/display/offer/Description'
import Similar from '@components/display/offer/Similar'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'
import withOfferIncreaseView from '@hoc/withOfferIncreaseView'

import dbConnect from 'db/dbConnect'
import { getHeavy } from 'db/repo/ad'
import listAdsHeavy from 'db/repo/listAds/listAdsHeavy'
import usePageSeoWithOfferParams from 'src/seo/server/usePageSeoWithOfferParams'
// import makeDisplayTruckLinks from '@components/frontpage/functions/makeDisplayTruckLinks'

function DisplayHeavy ({ cubeLinks, offer, similar, seo }) {
    const user = offer?._user
    const isDeleted = offer?.tracking?.deleted

    return (
        <Layout>
            <Seo seo={seo} />
            <JsonLdDisplay buy={false} offer={offer} />
            <div style={{ background: 'var(--background-grey)'}}>
                <OfferActiveStateGuard offer={offer} />
                <DisplaySection gray>
                    <br/><Breadcrumbs locationPosition={3} /><br/>
                    <TitlePrice offer={offer} />
                </DisplaySection>

                <DisplaySection borders white>
                    <ActivePhotoContext offer={offer}>
                        <Triptic>
                            <Photo offer={offer} />
                            <UserDetails displayOn="desktop" offer={offer} user={user} />
                            <UserLocation user={user} offer={offer} />
                        </Triptic>
                        <Thumbnails offer={offer} />
                    </ActivePhotoContext>
                    <Flag offer={offer} />
                </DisplaySection>

                {
                    !isDeleted && <>
                        <div className="container">
                            <ShortSpecifications offer={offer} />
                        </div>

                        <DisplaySection gray>
                            <TwoColumns>
                                <Specifications
                                    carfax={true}
                                    linkBase={HEAVY_LINK_BASE}
                                    offer={offer} />
                                <Equipment offer={offer} />
                            </TwoColumns>
                        </DisplaySection>

                        <DisplaySection white>
                            <Description offer={offer} />
                            <UserDetails displayOn="mobile" offer={offer} user={user} />
                        </DisplaySection>
                    </>
                }

                <DisplaySection white>
                    <Similar linkBase={HEAVY_LINK_BASE} offer={offer} offers={similar} />
                    <br />
                </DisplaySection>
            </div>

            <FrontpageLinks sections={cubeLinks} />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()
    const query = context.query
    const offer = await getHeavy(query)

    if (offer == null) {
        return {
            redirect: {
                permanent: false,
                destination: '/samochody-ciezarowe',
            }}
    }

    const { ads: similar } = await listAdsHeavy({
            marka: offer?.make,
            model: offer?.model,
        }, {
            match: { _shortid: { $ne: offer?._shortid }},
            limit: 2,
            pagination: false,
        })

    return {
        props: {
            // cubeLinks: await makeDisplayTruckLinks(query, '/samochody-ciezarowe'),
            offer,
            similar,
            seo: await usePageSeoWithOfferParams({
                pageId: 'oferta-samochod-dostawczy', // <- TODO: change in admin then here for unique meta
                query,
                offer,
            })
        }
    }
}

export default withOfferIncreaseView(DisplayHeavy)
